<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <logo-vsl-booster />
        </b-link>

        <b-card-title class="mb-1">
          Seja bem vindo(a) Administração DKP
        </b-card-title>
        <b-card-text class="mb-2">
          Entre com email do usuario para fazer o login.
        </b-card-text>

        <!-- form -->
        <validation-observer
          ref="loginValidation"
          #default="{invalid}"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="login"
          >

            <!-- email -->
            <b-form-group
              label-for="email"
              label="Email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="userEmail"
                  name="login-email"
                  :state="errors.length > 0 ? false:null"
                  placeholder="john@example.com"
                  autofocus
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- email -->
            <b-form-group
              label-for="token_admin"
              label="Token Admin"
            >
              <validation-provider
                #default="{ errors }"
                name="token_admin"
                rules="required"
              >
                <b-form-input
                  id="token_admin"
                  v-model="userTokenAdmin"
                  name="token_admin"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Ex. 0bdf10d7-fff8-4cde-9a5d-fd9905a77368"
                  autofocus
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              type="submit"
              block
              :disabled="invalid"
            >
              Entrar
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BCardTitle, BCardText,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import LogoVslBooster from '@/components/LogoVslBooster.vue'
import api from '@axios'
import useJwt from '@/auth/jwt/useJwt'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    LogoVslBooster,
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    BCardText,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: '',
      userTokenAdmin: '',
      required,
      email,
    }
  },
  computed: {
    userData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
  },
  mounted() {
    if (!this.$can('all', 'manage')) {
      this.$router.push(getHomeRouteForLoggedInUser(this.userData.user_role || 'cleinte'))
    }
  },
  methods: {
    async login() {
      await api.post('/auth/admin', { user_email: this.userEmail, token_admin: this.userTokenAdmin })
        .then(response => {
          const { userData } = response.data

          localStorage.setItem('lgn_admin', this.userData.user_role)
          localStorage.setItem('lgn_admin_metadata', JSON.stringify({
            user_email: this.userData.user_email,
            token_admin: this.userData.uuid,
          }))
          useJwt.setToken(response.data.accessToken)
          useJwt.setRefreshToken(response.data.refreshToken)
          localStorage.setItem('userData', JSON.stringify(userData))
          this.$ability.update(userData.ability)

          this.$router.replace(getHomeRouteForLoggedInUser(userData.user_role))

            .then(() => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `Bem-vindo ${userData.user_name || userData.user_sobrenome}`,
                  icon: 'CoffeeIcon',
                  variant: 'success',

                },
              })
            })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error Inesperado',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: error.response.data.message || 'Erro ao fazer login',
            },
          })
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
